export default __webpack_public_path__ + "static/media/icon_help.fc1a52d6.svg";